module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-CondIt.ce6b580.ttf";